import { render, staticRenderFns } from "./PIDSelect.vue?vue&type=template&id=dee22828"
import script from "./PIDSelect.vue?vue&type=script&lang=js"
export * from "./PIDSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports